import styled from "styled-components";

export const Error = styled.p`
    color: red;
    font-size: 1.2rem;
    margin-top: 60px;
    z-index: 9;
    position: absolute;
    width: 300px;
    line-height: 1.4;
    font-family: 'Inter', sans-serif;
`

export const Wrapper = styled.div`
    margin-bottom: 16px;
    position: relative;
    & * {
        font-size: 102% !important;
    }
     & #static-label {
        font-size: 14px !important; /* Or any other font-size you wish to apply */
    }
`